import React, { useState, useEffect, useRef } from "react";
import { Modal } from "./Modal";
// import "./AddSourceModal.css";
import "./ProductDemoModal.css";
import { graphql, createFragmentContainer } from "react-relay";
import InlineNotification from "./InlineNotification";
import AddSubscriptionMutation from "../mutations/AddSubscriptionMutation";
import AddSmallScreenSubMutation from "../mutations/AddSmallScreenSubMutation";
import { useTheme } from "../contexts/ThemeContext";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { useMediaQuery } from "react-responsive";
// import { useNavigate, Link } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "nuka-carousel";
import topicTrendsDemo from "../backgrounds/demo/browser-window-03.png";
import summaryDemo from "../backgrounds/demo/summarize-image.png";
import sentimentDemo from "../backgrounds/demo/positive-negative-image.png";
import addSource from "../backgrounds/demo/organize-image.png";
import toolsImage from "../backgrounds/tools-image.png";
import shareImage from "../backgrounds/demo/share-image.png";
import notesImage from "../backgrounds/demo/rich-text-notes.png";
import analyseIcon from "../icons/trending_up-24px.svg";

function ProductDemoModal(props) {
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const [style, setStyle] = useState({
        modal: {
            width: "48rem",
            height: "auto",
        },
        newTextBox: {
            display: "block",
        },
    });

    const user_Subscription = props.user_Subscription;
    const { is_premium } = props.user;
    const theme = useTheme();

    const { isAddSourceModalActivated } = props.settings;

    function onCancelClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    function onTrialButtonClick(e) {
        e.preventDefault();
        if (!is_premium) {
            navigate("/upgrade");
        }
    }

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode == 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    return (
        <div>
            <Modal
                style={style}
                title={"Tips"}
                isModalActive={props.isModalActive}
                setIsModalActive={props.setIsModalActive}
            >
                <Carousel
                    cellAlign="center"
                    wrapAround={false}
                    className="demo-carausel"
                >
                    <div className="demo-container">
                        <div className={`demo-content`}>

                            <h3
                                className={`demo-headline theme-${theme.paragraph}`}
                            >
                               Get Started with the Real Information 
                            </h3>
                            <p
                                className={`demo-headline-leading theme-${theme.paragraph}`}
                            >
                                <strong>The Feedgram</strong> is a powerful tool more than a feed reader. Click next to find out how to stay ahead of the curve by focusing on real information.
                            </p>
                            <p
                                className={`demo-description theme-${theme.paragraph}`}
                            >
                                {" "}
                            </p>
                        </div>

                        <img
                            className="demo-leading-image"
                            width="500"
                            src={toolsImage}
                        />
                    </div>

                    <div className="demo-container">
                        <div className={`demo-content`}>
                            <h3
                                className={`demo-headline theme-${theme.paragraph}`}
                            >
                                {" "}
                                Organize Feeds into Folders{" "}
                            </h3>
                            <p
                                className={`demo-description theme-${theme.paragraph}`}
                            >
                                Click the Add button at the bottom of the left
                                sidebar. Add selected feeds to a folder and make
                                your favorite category out of them.
                            </p>{" "}
                        </div>
                        <img width="500" src={addSource} />
                    </div>

                    <div className="demo-container">
                        <div className={`demo-content`}>
                            <h3
                                className={`demo-headline theme-${theme.paragraph}`}
                            >
                                {" "}
                                Bookmark and Share{" "}
                            </h3>
                            <p
                                className={`demo-description theme-${theme.paragraph}`}
                            >
                                Click on the "three-dots" button below every
                                post and select Bookmark or Share.
                            </p>{" "}
                        </div>
                        <img width="500" src={shareImage} />
                    </div>

                    <div className="demo-container">
                        <div className={`demo-content `}>
                            <h3
                                className={`demo-headline theme-${theme.paragraph}`}
                            >
                                Find News Faster with Topic Trends
                                <img
                                    className={`demo-analyse-button`}
                                    src={analyseIcon}
                                />
                            </h3>
                            <p
                                className={`demo-description theme-${theme.paragraph}`}
                            >
                                The Feedgram analyzes the articles and finds the
                                relevant topics in a feed. Click on the Analyse
                                button on the header and select one more topic
                                and click the 'Find Articles' button.
                                {/* <a */}
                                {/*     href="https://blog.thefeedgram.com/blog/a-beautifully-designed-rss-reader-that-just-makes-sense/" */}
                                {/*     target="_blank" */}
                                {/* > */}
                                {/*     Learn More */}
                                {/* </a> */}
                            </p>
                            {!is_premium ? (
                                <Link
                                    className="demo-link-upgrade"
                                    to="/upgrade"
                                >
                                    {" "}
                                    Upgrade Now{" "}
                                </Link>
                            ) : null}
                        </div>
                        <img src={topicTrendsDemo} />
                    </div>

                    <div className="demo-container">
                        <div className={`demo-content`}>
                            <h3
                                className={`demo-headline theme-${theme.paragraph}`}
                            >
                                {" "}
                                Summarize Long Articles{" "}
                            </h3>
                            <p
                                className={`demo-description theme-${theme.paragraph}`}
                            >
                                Get a quick summary of long articles and save
                                time reading everything to get a full overview.
                                Click on the "Diamond Button" on the header of
                                the post view. Click it again to toggle between
                                the summary and the original article.&nbsp;
                                {/* <a */}
                                {/*     href="https://blog.thefeedgram.com/blog/a-beautifully-designed-rss-reader-that-just-makes-sense/" */}
                                {/*     target="_blank" */}
                                {/* > */}
                                {/*     Learn More */}
                                {/* </a> */}
                            </p>

                            {!is_premium ? (
                                <Link
                                    className="demo-link-upgrade"
                                    to="/upgrade"
                                >
                                    {" "}
                                    Upgrade Now{" "}
                                </Link>
                            ) : null}
                        </div>
                        <img width="500" src={summaryDemo} />
                    </div>

                    <div className="demo-container">
                        <div className={`demo-content`}>
                            <h3
                                className={`demo-headline theme-${theme.paragraph}`}
                            >
                                {" "}
                                Take Rich-Text Notes{" "}
                            </h3>
                            <p
                                className={`demo-description theme-${theme.paragraph}`}
                            >
                                You can add notes to articles to keep things
                                memorable. Click on the "three-dots" option
                                button below the articles on the home page and
                                select "Add Note" or click on the Add Note
                                Button on the header if you are in the post
                                view.
                            </p>
                            {!is_premium ? (
                                <Link
                                    className="demo-link-upgrade"
                                    to="/upgrade"
                                >
                                    {" "}
                                    Upgrade Now{" "}
                                </Link>
                            ) : null}
                        </div>
                        <img width="500" src={notesImage} />
                    </div>
                    <div className="demo-container">
                        <div className={`demo-content `}>
                            <h3
                                className={`demo-headline theme-${theme.paragraph}`}
                            >
                                {" "}
                                Find Positive and Negative News{" "}
                            </h3>
                            <p
                                className={`demo-description theme-${theme.paragraph}`}
                            >
                                The Feedgram's unique Sentimental Analysis will
                                help you sort out Positive and Negative news
                                trends in articles easily and help you find news
                                trends. Click on the Analyse button on the
                                header and select Article sentiment. Select one
                                or more posts and click "Find Articles".
                                {/* <a */}
                                {/*     href="https://blog.thefeedgram.com/blog/a-beautifully-designed-rss-reader-that-just-makes-sense/" */}
                                {/*     target="_blank" */}
                                {/* > */}
                                {/*     Learn More */}
                                {/* </a> */}
                            </p>

                            {!is_premium ? (
                                <Link
                                    className="demo-link-upgrade"
                                    to="/upgrade"
                                >
                                    {" "}
                                    Upgrade Now{" "}
                                </Link>
                            ) : null}
                        </div>
                        <img src={sentimentDemo} />
                    </div>

                    {!is_premium ? (
                        <div className="demo-container">
                            <div className="demo-trial-button-container">
                                <button
                                    onClick={onTrialButtonClick}
                                    className="trial-btn"
                                >
                                    Start Free Trial
                                </button>
                            </div>
                        </div>
                    ) : null}
                </Carousel>
            </Modal>
        </div>
    );
}

export default ProductDemoModal;
